// import
import actionCreatorFactory from "typescript-fsa";
import {AppConfig} from "../models/AppConfig";

// the factory
const actionCreator = actionCreatorFactory();

//++++++++++++++++++++++
// App handling
//++++++++++++++++++++++

export const ACTION_APP__WRITE_CONFIG = actionCreator<{ config: AppConfig }>('ACTION_APP__WRITE_CONFIG');

export const ACTION_APP__START = actionCreator<{ content: any }>('ACTION_APP__START');
export const ACTION_APP__READY = actionCreator<{}>('ACTION_APP__READY');
export const ACTION_APP__RESTART = actionCreator<{}>('ACTION_APP__RESTART');

export const ACTION_APP__GOTO_OVERVIEW = actionCreator<{}>('ACTION_APP__GOTO_OVERVIEW');
export const ACTION_APP__CLEAR_LAST_STATE = actionCreator<{}>('ACTION_APP__CLEAR_LAST_STATE');

export const ACTION_APP__SET_DATA_VIEW_360 = actionCreator<{ data: any }>('ACTION_APP__SET_DATA_VIEW_360');
export const ACTION_APP__SET_DATA_IMAGE_MOVIE = actionCreator<{ data: any }>('ACTION_APP__SET_DATA_IMAGE_MOVIE');

//++++++++++++++++++++++
// Locale handling
//++++++++++++++++++++++

export const ACTION_APP__LOCAL_CHANGE = actionCreator<{ newLocale: string }>('ACTION_APP__LOCAL_CHANGE');


//++++++++++++++++++++++
// OverviewScreen - Main Menu
//++++++++++++++++++++++

export const ACTION_OVERVIEW__SET_DATA = actionCreator<{ data: any }>('ACTION_OVERVIEW__SET_DATA');
export const ACTION_OVERVIEW__FEATURE_SHOW = actionCreator<{ link: string }>('ACTION_OVERVIEW__FEATURE_SHOW');
export const ACTION_OVERVIEW__FEATURE_HIDE = actionCreator<{ link: string }>('ACTION_OVERVIEW__FEATURE_HIDE');
export const ACTION_OVERVIEW__FEATURE_HIDE_ALL = actionCreator<{}>('ACTION_OVERVIEW__FEATURE_HIDE_ALL');

//++++++++++++++++++++++
// FeatureDetailScreen
//++++++++++++++++++++++

export const ACTION_FEATURES__SET_DATA = actionCreator<{ data: any }>('ACTION_FEATURES__SET_DATA');
export const ACTION_FEATURES__URL_CHANGE = actionCreator<{ url: string }>('ACTION_FEATURES__URL_CHANGE');
export const ACTION_FEATURES__CLEAR_ALL_URLS = actionCreator<{}>('ACTION_FEATURES__CLEAR_ALL_URLS');
export const ACTION_FEATURES__CLEAR_LAST_URL = actionCreator<{}>('ACTION_FEATURES__CLEAR_LAST_URL');

//++++++++++++++++++++++
// Debug console
//++++++++++++++++++++++

export const ACTION_DEBUG__CONSOLE_SHOW = actionCreator<{}>('ACTION_DEBUG__CONSOLE_SHOW');
export const ACTION_DEBUG__CONSOLE_HIDE = actionCreator<{}>('ACTION_DEBUG__CONSOLE_HIDE');